// endpoints
export const endpoints = {
  evaluate: {
    boolean: 'evaluate/v1/boolean',
    variant: 'evaluate/v1/variant',
    batch: 'evaluate/v1/batch',
  },
};
